import { goto } from "./realization.goto";
export * from "./RealizationRoutes";

export const realizationRoute = {
  goto: goto,
};
